import { isEmptyValue } from 'app/utils/helper';
import FormGroup from 'components/FormGroup';
import FormSelect from 'components/FormSelect';
import { CustomerInfoKeyType } from 'types/customer';
import { printf } from 'utils/i18n';

export interface FamilyMemberProps {
    disabled?: boolean;
}

export interface FamilyMemberFormutil {
    family_member: number;
}

export const defaultFieldsOfFamilyMember: CustomerInfoKeyType[] = ['family_member'];

const numberOfDependentsOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(item => ({
    label: item,
    value: item
}));

const FamilyMember: React.FC<FamilyMemberProps> = ({ disabled }) => {
    return (
        <div className="family-info-root">
            <FormGroup
                name="family_member"
                label={__('Number of Dependents')}
                checker={value => {
                    if (disabled) {
                        return true;
                    }

                    if (isEmptyValue(value)) {
                        return printf(__('Please select your %s'), __('number of dependents'));
                    }

                    return true;
                }}>
                <FormSelect placeholder={__('Please Select')} disabled={disabled} options={numberOfDependentsOptions} />
            </FormGroup>
        </div>
    );
};

export default FamilyMember;
